import React from "react";
import { useInView } from "react-intersection-observer";
import useFetch from "../hooks/useFetch";
import SkillSkeleton from "../skeletons/SkillSkeleton";
import Heading from "./Heading";
import Skill from "./Skill";

const Skills = () => {
  const { ref, inView } = useInView({ threshold: 0.2 });

  const { data: skills, isLoading } = useFetch(
    `${process.env.REACT_APP_BACKEND_URL}/api/skills?populate=*&sort=publishedAt:asc`
  );
  const frontendSkills = skills.filter(
    (s) => s.attributes.category === "frontend"
  );
  const backendSkills = skills.filter(
    (s) => s.attributes.category === "backend"
  );
  return (
    <section ref={ref} className="bg-scColor" id="skills">
      <div className="container py-[40px] sm:py-[60px] md:py-[90px]">
        <div className="mb-10 xs:mb-12 md:mb-20">
          <Heading title={"My Special Skills Here"} subTitle="Special Skills" />
        </div>
        <div className="flex justify-between gap-4 flex-col sm:flex-row sm:gap-2 md:gap-8 lg:gap-12">
          <div className="w-full sm:w-1/2 bg-prColor/80 px-4 sm:px-16 py-8 sm:py-12 rounded">
            <h2 className="text-xl xs:text-2xl text-dark font-['Merriweather'] font-bold mb-8 xs:mb-12">
              Front end Skills
            </h2>
            <div className="text-light grid grid-cols-3 gap-8 sm:gap-12">
              {!isLoading &&
                frontendSkills.map((s, i) => (
                  <Skill
                    name={s.attributes.name}
                    url={s.attributes.img.data.attributes.url}
                    inView={inView}
                    key={i}
                  />
                ))}
              {isLoading &&
                [1, 2, 3, 4, 5, 6].map((n) => <SkillSkeleton key={n} />)}
            </div>
          </div>
          <div className="w-full sm:w-1/2 bg-prColor/80 px-4 sm:px-16 py-8 sm:py-12 rounded">
            <h2 className="text-xl xs:text-2xl text-dark font-['Merriweather'] font-bold mb-10">
              Backend Skills
            </h2>
            <div className="text-light grid grid-cols-3 gap-8 sm:gap-12">
              {!isLoading &&
                backendSkills.map((s, i) => (
                  <Skill
                    name={s.attributes.name}
                    url={s.attributes.img.data.attributes.url}
                    inView={inView}
                  />
                ))}
              {isLoading && [1, 2, 3].map((n) => <SkillSkeleton key={n} />)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
